export function formatFullName(firstName, lastName) {
  return `${firstName} ${lastName}`;
}
